import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { GalleryCarouselProps } from './types/fullScreenMediaGallery.types';
import { FullScreenMediaGalleryModel } from './models/fullScreenMediaGallery.model';
import GalleryCarousel from '../@shared/galleryCarousel';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const FullScreenMediaGallery: FC<GalleryCarouselProps> = (props) => {
    const model = new FullScreenMediaGalleryModel(props);

    // Component is unreleased
    if (model.isUnreleased) {
        return <UnreleasedComponent/>
    }

    const hasSlides = (model?.carouselSlide || []).length > 0;

    if (!hasSlides) {
        return null;
    }

    return (
        <>
            <GalleryCarousel slides={model.carouselSlide}/>
        </>
    );
};

export default withSitecoreContext()(FullScreenMediaGallery);
